import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";
import Constants from "common/constant";

const firebaseConfig = {
  apiKey: Constants.apiKey,
  authDomain: Constants.authDomain,
  projectId: Constants.projectId,
  appId: Constants.appId,
  measurementId: Constants.measurementId,
};

const firebase = initializeApp(firebaseConfig);

export default firebase;

export const fetchAuthToken = async () => {
  const auth = getAuth(firebase);
  if (!auth.currentUser) {
    throw new Error("User not authenticated");
  }
  return auth.currentUser.getIdToken(false);
};
